/* eslint-disable jsx-a11y/anchor-has-content */
import * as React from 'react';

import Footer from '../components/footer/footer';
import Header from '../components/header/header';
import Navbar from '../components/navbar/navbar';
import '../styles/App.css';
import _gConstants from '../configuration/constants.json';

function Reject() {
  document.title=_gConstants.REJECT_PAGE_TITLE;
  return (
    <div>
      <Navbar/>
      <Header status={_gConstants.REJECT_BANNER_STATUS}/>
      <div className="content">
        <div className="text-width">
          <span className="h1">Schade, dass es Dir nicht gefällt</span>
          <p className="text">
            Wir haben Deinen Auftrag gelöscht. Es kommt kein Vertrag zustande.<br/><br/>
            Schau Dich doch nochmal in unserem <a href="https://www.vodafone.de/index.html" target="_parent">Shop</a> um. Du bist schon Kunde? 
            Dann ist die Produktseite von MeinVodafone genau das Richtige für Dich. 
            Hier findest Du die Möglichkeiten, um Deinen Vertrag optimal anzupassen.
          </p>
          <div className="button-container">
            <a
              href="https://www.unitymedia.de/benutzerkonto/login/zugangsdaten"
              target="_self"
              className="btn"
            >
              Zu MeinVodafone
            </a>
          </div>
        </div>
        <div className="division"></div>
      </div>
      <Footer/>
    </div>
  );
}

export default Reject;
